import css from './index.module.css'

export const ScanditSDKVersionText = () => <div className={css.version}>v.{SCANDIT_SDK_VERSION}</div>
